<template>
  <div  class="nuttrema-layout-three-vertical">
    <div v-if="checkSlot('top')" class="nuttrema-layout-three-vertical__top">
      <slot name="top"></slot>
    </div>
    <div v-if="checkSlot('middle')" class="nuttrema-layout-three-vertical__middle">
      <slot name="middle"></slot>
    </div>
    <div v-if="checkSlot('bottom')" class="nuttrema-layout-three-vertical__bottom">
      <slot name="bottom"></slot>
    </div>
  </div>
</template>

<script>
import { has } from 'lodash';

export default {
  name: 'nuttrema-layout-three-vertical',
  methods: {
    checkSlot(slot) {
      return has(this.$slots, slot) && this.$slots[slot][0].tag !== undefined;
    },
  },
};
</script>

<style lang="scss" scoped>
  .nuttrema-layout-three-vertical {
    flex-grow: 1;
    display: flex;
    align-self: stretch;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    // overflow-y: auto;

    .nuttrema-layout-three-vertical__top {
      display: flex;
      flex-shrink: 0;
      align-self: stretch;
    }

    .nuttrema-layout-three-vertical__middle {
      flex-grow: 1;
      display: flex;
      flex-shrink: 1;
      overflow-y: auto;
      overflow-x: hidden;
      position: relative;
      align-self: stretch;
      height: 1px;
      min-height: 1px;
    }

    .nuttrema-layout-three-vertical__bottom {
      display: flex;
      flex-shrink: 0;
      align-self: stretch;
    }

    &.is-disabled-middle-scroll {
      .nuttrema-layout-three-vertical__middle {
        overflow-y: unset;
      }
    }

    &.is-enabled-middle-scroll {
      overflow-y: unset;
    }

    &.is-in-mobile-ready-layout {
      padding-bottom: 1em;
      .nuttrema-layout-three-vertical__middle {
        height: 100%;
      }
    }

    &.is-top-column {
      .nuttrema-layout-three-vertical__top {
        flex-direction: column;
      }
    }

    .sticky & {
      .nuttrema-layout-three-vertical__middle {
        height: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/layout/nuttrema-layout-three-vertical.vue